module.exports = __webpack_public_path__ + "static/img/analysis.c7622b09.png";